module.exports = __webpack_public_path__ + "static/location.704a5a5d.svg";